
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trademark-registration-services",
      function () {
        return require("private-next-pages/trademark-registration-services/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trademark-registration-services"])
      });
    }
  